// tutti gli schemi per i parametri di input API sono definiti qui
import { z } from 'zod';
import { territorialIdSchema } from './paramTypeSchema.js';
import { profileAttributeSchema, profileDefRowSchema } from './profileDefSchema.js';
export const inputIdSchema = z.object({ id: z.number().int().positive() }); // ID numerico positivo
export const inputIdsSchema = z.object({ ids: z.array(z.number().int().positive()).min(1) }); // Array di ID numerici positivi
export const inputQuerySchema = z.object({
    whereClause: z.string().optional().default(''),
    params: z.array(z.any()).optional().default([]),
    orderBy: z.string().optional(),
    limit: z.number().int().positive().max(100).default(20),
});
export const inputQueryPagedSchema = z.object({
    page: z.number().int().positive().default(1),
    limit: z.number().int().positive().max(100).default(20),
    whereClause: z.string().optional().default(''),
    params: z.array(z.any()).optional().default([]),
    orderBy: z.string().optional()
}); // Parametri per query paginata
export const inputMatchAttributesToBonusSchema = z.object({
    territorialId: territorialIdSchema, // ID territoriale
    profileAttributes: z.array(profileAttributeSchema) // Attributi del profilo da confrontare
}); // Parametri per il matching degli attributi del profilo con i bonus
export const inputMatchAttributesToBonusLazySchema = z.object({
    territorialId: territorialIdSchema,
    profileAttributes: z.array(profileAttributeSchema),
    categoriesFilter: z.array(z.number().int().positive()).optional().default([]),
    limit: z.number().int().positive().default(50),
}); // Parametri per il matching degli attributi del profilo con i bonus, con paginazione lazy
export const inputMatchProfileToBonusSchema = z.object({
    profile: z.union([
        z.number(),
        profileDefRowSchema.partial()
    ])
});
export const inputUpdatePartialSchema = z.object({
    id: z.number(),
    row: z.record(z.any()) // Oggetto generico per i campi parziali
}); // Parametri per l'update parziale
export const inputSimilaritySearchSchema = z.object({
    text: z.string().min(1),
    limit: z.number().int().positive().max(100).default(5)
}); // Parametri per la ricerca di similarità
//# sourceMappingURL=managerInputApiSchema.js.map